import Vue from "vue";
import App from "./App.vue";
import "./plugins/vuetify";
import "./plugins/GoogleMaps";
import VueGtag from "vue-gtag";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import Vue2TouchEvents from "vue2-touch-events";
// import VueAwesomeSwiper from "vue-awesome-swiper";
import infiniteScroll from "vue-infinite-scroll";
import "animate.css";
import L from "leaflet";
import jQuery from "jquery";
import "lazysizes";
import VueMasonry from 'vue-masonry-css'
import _ from "lodash";
import CryptoJS from "crypto-js";
// import firebase_config from "../firebase_config";
//import firebase from "firebase/app";
//import "firebase/messaging";

import { defineCustomElements } from '@ionic/pwa-elements/loader';
// import Vuelidate from "vuelidate";

window.CryptoJS = CryptoJS;
window.L = L;
window._ = _;
window.axios = axios;
window.$ = window.jQuery = jQuery;

// import VueAnalytics from "vue-analytics";

// ------------ css style
// require styles
import "swiper/dist/css/swiper.css";
import "hooper/dist/hooper.css";

import "leaflet/dist/leaflet.css";

// this part resolve an issue where the markers would not appear
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
	iconRetinaUrl: require("@/assets/img/new_icons/my_location_2.svg"),
	iconUrl: require("@/assets/img/new_icons/my_location_2.svg"),
	shadowUrl: require("@/assets/img/new_icons/transparent.png")
});

/**
 * Definimi i komponenteve baze, duhet te jete te folderi "./components/base_components", duhet te filloje me "/Base"
 */

const requireComponent = require.context(
	"./components/base_components",
	false,
	/Base[A-Z]\w+\.(vue|js)$/
);

/**
 * Pjesa per te futur ne menyre automatike komponentet baze
 */

requireComponent.keys().forEach(fileName => {
	const componentConfig = requireComponent(fileName);
	const componentName = upperFirst(
		camelCase(
			fileName
			.split("/")
			.pop()
			.replace(/\.\w+$/, "")
		)
	);
	Vue.component(componentName, componentConfig.default || componentConfig);
});

// Vue.use(VueAnalytics, {
//   id: "",
//   router
// });

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(VueAxios, axios);
Vue.use(Vue2TouchEvents, { swipeTolerance: 30 });
Vue.use(infiniteScroll);
Vue.use(VueMasonry);

Vue.use(VueGtag, {
	config: { id: "G-LYDBHCRVHW", storage: 'none', },
	pageTrackerTemplate(to) {
		let langpath = 'sq'
		if (vue.$store) {
			langpath = vue.$store.state.type_language == 2 ? 'en' : 'sq'
		}
		//let page_location = window.location.href.split('#')
		//page_location = 'https://app.tiranamobility.altirana.com/' + langpath + page_location[1]
		let page_location = window.location.href.replace('#', langpath)
		//console.log(page_location)
		const payload = {
			page_title: to.meta && to.meta.title ? to.meta.title : to.name,
			page_path: to.path,
			page_location: page_location
		}
		//console.log(payload)
		return payload
	}
}, router)

var vue = new Vue({
	name: 'TiranaIme',
	router,
	store,
	directives: { infiniteScroll },
	render: h => h(App),
	data(){
		return {
			showDPDialog: true,
			firebaseinited: false
		}
	},
	created(){
		this.checkDPDialog()
		defineCustomElements(window);
	},
  	methods: {
		setAccepteDP(){
			localStorage.acceptedp = 1.0
			this.checkDPDialog()
		},
		checkDPDialog(){
			if (localStorage.acceptedp) {
				this.showDPDialog = false
			} else {
				this.showDPDialog = true
			}
		},
  	}
}).$mount("#app");

export default vue;